module.exports = __webpack_public_path__ + "static/img/sssd.1e537a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sssd.png
// module id = yz/o
// module chunks = 0